export default __webpack_public_path__ + "static/media/Alert.8f210199.svg";